// extracted by mini-css-extract-plugin
export default {"drawerview":"drawerview_b29951a4861380c84803","background":"background_f2aa8199d9031d96170b"};